import { createAsyncThunk } from '@reduxjs/toolkit';

import { PERFORMANCE_MODE_ENABLED_KEY } from '../../constants';
import { MOBILE_DEVICES_PERFORMANCE_MODE_SET } from '../../types';
import * as globalSelectors from '../../selectors';
import constants from './constants';
import { GlobalState } from '../../reducers';

const { ENABLED, DISABLED } = constants.PERFORMANCE_MODE_STATES;

const setPerformanceMode = createAsyncThunk(
  MOBILE_DEVICES_PERFORMANCE_MODE_SET,
  (enable: boolean, { getState }) => {
    const realDeviceClient = globalSelectors.realDeviceClientSelector(getState() as GlobalState);

    window.localStorage.setItem(
      PERFORMANCE_MODE_ENABLED_KEY,
      enable ? ENABLED : DISABLED,
    );

    realDeviceClient?.setWebRtcEnabled(enable);

    return enable;
  },
);

export default {
  setPerformanceMode,
};
